import { getRegisterFunction } from '../../utils/register.js';
import { OneUxStackElement } from './OneUxStackElement.js';
export const register = getRegisterFunction(OneUxStackElement);
declare global {
  interface HTMLElementTagNameMap {
    'one-ux-stack': OneUxStackElement;
    "stack-fb81eefe6575a52b56cf186fa5c22f01": OneUxStackElement;
  }
}